import React from 'react';

import { PlatformLabel } from 'src/common/types/IssueDetailsType';

import { TagsBlock } from '../tags-block/TagsBlock';

interface LabelsPopupProp {
	labels: PlatformLabel[];
	isThreeColumns?: boolean;
}

export const LabelsBlock: React.FC<LabelsPopupProp> = ({ labels, isThreeColumns }) => {
	const automaticLabels = labels
		.filter((label) => label.isAutomatic)
		.map((label) => ({ ...label, values: [label.value] }));
	const customLabels = labels
		.filter((label) => !label.isAutomatic)
		.map((label) => ({ ...label, values: [label.value] }));

	return (
		<TagsBlock
			isThreeColumns={isThreeColumns}
			tagGroups={[
				{
					tags: automaticLabels
				},
				{ tags: customLabels }
			]}
		/>
	);
};
